export default __webpack_public_path__ + "static/media/login_button_back.b39406f3.png";